<template>
  <div>
    <article v-if="eligible_audience.isFetched" class="audience_container">
        <div>
            <p class="font_regular font_500  text_14">
                {{ $t('CAMPAIGN.ADD_STEP.ONE_OFF.ELIGIBLE_AUDIENCE') }}
            </p>
            <div class="credit_purple_box">
                <div>
                    <span class="font_500 text_16 text_black_primary">
                        {{eligible_audience.audience}}
                    </span>
                    <!-- <span class="font_500 text_12 text_black_secondary">
                        {{eligible_audience.costs}}
                        {{$t('CAMPAIGN.ADD_STEP.ONE_OFF.CREDIT')}}
                    </span> -->
                </div>
                <!-- <div class="available_credit_box">
                    <span class="available_credit available_credit_purple font_regular font_500  text_12">
                        {{$t('CAMPAIGN.ADD_STEP.ONE_OFF.AVAILABLE_CREDIT')}}
                        {{eligible_audience.available_credit}}
                    </span>
                </div> -->
            </div>
        </div>
    </article>
  </div>
</template>

<script>
export default {
    props:{
        eligible_audience:{
            type: Object,
            default: ()=>({})
        },
    },
    methods:{},
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.audience_container{
    display: flex;
    gap: 20px;
    border-radius: 10px;
    padding: 16px;
    width: fit-content;
    background-color: #F2E7FE;
    div{
        &:nth-child(1){
            max-width: 250px;
        }
        &:nth-child(2){
            max-width: 320px;
        }
    }
}


.credit_purple_box{
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
}
.available_credit_box{
    display: flex;
    align-items: center;
}
.available_credit{
    display: inline-block;
    border-radius: 20px;
    padding: 4px 12px;
    background-color: #FFECB2;
    color: #996600;
}
.available_credit_purple{
    background-color: #E5CEFD;
    color: #8D25F6;
}


.topup_box{
    display: flex;
    gap: 8px;
}
.topup{
    display: flex;
    align-items: center;
    gap: 4px;
    background: #fff;
    width: fit-content;
    padding: 10px 8px;
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    input{
        width: 100px;
        margin: 0;
        padding: 0;
        height: auto;
        border: none;
        text-align: right;
    }
}

</style>